import {Injectable} from "@angular/core";
import {MedId} from "felles-ng2/tjenester/datalager/datatjeneste";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {FavorittModell, FavorittRessursClient, FavorittType, TynnFavorittModell} from "../ressurser/generertNg2HttpKlient";
import {erFavorittHosKallendeBruker, HarFavoritter} from "../../modell/favoritterModellHjelpere";
import {BrukerkontekstTilbyder} from "../BrukerkontekstTilbyder";
import {i18n} from "felles-ng2/tjenester/i18n/Oversettelser";
import {erIkkeListe} from "felles-ng2/støttefunksjoner/lister";
import {erFavorittHosBruker} from "felles-ng2/modell/brukerModellHjelpere";

const debug = initDebugger('FavorittDatatjeneste');


/** Datalager for {@link FavorittModell}. */
@Injectable() //tilgjengeliggjøres via DatalagerModul
export class FavorittDatatjeneste {

    //@todo når vi er klarer til å bruke denne tjenesten i komp som lister ut brukers favoritter legger vi til dette...
    /*/!** Lager for {@link TynnFavorittModell}.
     * Uten forelder, da vi ikke gjør oppslag mot noen logisk forelder *!/
    private favoritterLager = createStore(
      {name: 'favoritter'},
      withEntities<TynnFavorittModell>());*/

    constructor(private favorittRessurs: FavorittRessursClient, private kontekst: BrukerkontekstTilbyder) {
    }

    /** Sann dersom angitte entitet er markert som favoritt av angitt bruker. */
    erFavoritt(entitet: HarFavoritter): boolean {
        if (erIkkeListe(entitet?.favoritter)) return false;
        return erFavorittHosBruker(entitet!.favoritter, this.kontekst);
    }

    /**
     * Registrerer angitt entitet som brukers favoritt dersom ikke allerede markert som favoritt,
     * eller fjernes angitt entitet som brukers favoritt.
     *
     * Merk at man normalt vil kalle tjeneste på domene-spesifikk datatjeneste for endring av favoritt-markering av entitet slik
     * at dette datalageret kan oppdatere sitt interne lager
     */
    endreFavorittmarkering(entitet: HarFavoritter & MedId, type: FavorittType): Promise<TynnFavorittModell[]> {
        const kall = erFavorittHosKallendeBruker(entitet, this.kontekst.autentisertBruker()) ?
          this.favorittRessurs.slettSomFavoritt(type, entitet.id) :
          this.favorittRessurs.markerSomFavoritt(type, entitet.id);
        return kall.somPromiseVisMeldingVedFeil(i18n('Kunne ikke oppdatere favorittmarkering'))
    }
}

